// Tutorial: A React SPA using MSAL React to authorize users for calling a protected web API on AAD
//   https://github.com/IvanFarkas/msal-react-call-api/tree/main/3-Authorization-II/1-call-api
import { LogLevel } from '@azure/msal-browser';
import { CLIENT_ID, CLIENT_ID_OMDC, REACT_APP_VAM_SAML, redirectURI, token_ID, token_ID_OMDC } from './urls';
import Cookies from "js-cookie";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${token_ID}/oauth2/v2.0/token`,
    redirectUri: redirectURI,
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            return;

          case LogLevel.Info:
            return;

          case LogLevel.Verbose:
            return;

          case LogLevel.Warning:
            return;
        }
      },
    },
  },
};
export const msalConfigOmdc = {
    auth: {
      clientId: CLIENT_ID_OMDC,
      authority: `https://login.microsoftonline.com/${token_ID_OMDC}/oauth2/v2.0/token`,
      redirectUri: redirectURI,
      postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
  
            case LogLevel.Info:
              console.info(message);
              return;
  
            case LogLevel.Verbose:
              // console.debug(message);
              return;
  
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        },
      },
    },
  };

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};

